import { ChangeEvent, useState } from 'react';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { useStatsContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsContext';
import StatsTable from './StatsTable';
import CategoriesList from './CategoriesList';
import CategoriesSelect from './CategoriesSelect';
import { ExpandAllButton, CollapseAllButton } from '@creditflowresearch/uilib/TriggerExpand/ExpandCollapseButtons';
import { Tile, TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import { getTrimmedString } from '@/creditflowresearch/ui/common/helpers/getTrimmedString';

import styles from './styles.module.scss';

const StatsList = ({ columns }) => {
  const {
    statsCollection: {
      debouncedSearch,
      debouncedSearchString,
      totalCount,
      isFetching,
    },
    tableTitle,
    isExpanded,
    setIsExpanded,
  } = useStatsContext();

  const [search, setSearch] = useState(debouncedSearchString);

  const onSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setSearch(value);
    const filteredValue = getTrimmedString(value);

    if (filteredValue === null) return;

    debouncedSearch(filteredValue);
  };

  const expandAll = () => {
    setIsExpanded(true);
  };

  const collapseAll = () => {
    setIsExpanded(false);
  };

  const ExpandCollapseButton = isExpanded ? CollapseAllButton : ExpandAllButton;

  return (
    <Tile
      layout="grid"
      templateColumns={ { sm: '1fr', xl: '250px 1fr' } }
      dataTest="statsTile"
    >
      <div className={ styles.categoriesContainer }>
        <CategoriesList />
      </div>
      <Flex direction="column" grow="1" shrink="1" className={ styles.statsContainer } dataTest="statsContainer">
        <TileHeader title={ <Title title={ tableTitle } /> } dataTest="subTitleStats">
          <Flex direction="row" align="center" gap={ 10 } alignSelf={ { sm: 'stretch' } }>
            <SearchInput
              onChange={ onSearchChange }
              value={ search }
              placeholder="Filter by Name or Description"
              className={ styles.searchInputField }
              formFieldClassName={ styles.searchFormField }
              dataTest="formSearchInput"
            />
            <div className={ styles.expandCollapseBtn }>
              <ExpandCollapseButton
                onClick={ isExpanded ? collapseAll : expandAll }
                dataTest="expandCollapseIcon"
                disabled={ !totalCount || isFetching }
              />
            </div>
          </Flex>
        </TileHeader>
        <div className={ styles.categoriesSelectContainer }>
          <CategoriesSelect />
        </div>
        <StatsTable columns={ columns } />
      </Flex>
    </Tile>
  );
};

export default StatsList;
